// @todo More than one `const` declaration might throw JS exception if there's
// more than one product selector on a page - like with exit intent modals.
const priceSelectorV2 = {
  hasShoppingParam: false,
  init: function () {
    console.log("Init productSelectorV2");
    const that = this;
    const isES = window.isES;

    this.hasShoppingParam =
      new URLSearchParams(window.location.search).get("shopping") == "1";

    this.preSelectSSOption();

    if (isES) {
      document.querySelectorAll(".es-dependent").forEach(function (el) {
        el.classList.add("es-dependent-show");
      });
    }

    // `click` event listener for each card
    document.querySelectorAll(".pdp-card").forEach(
      /** @param {HTMLDivElement} card */ function (card) {
        card.addEventListener("click", function (e) {
          e.stopPropagation();

          const pdpElement = this.closest(".pdp-selector");
          if (!pdpElement) {
            return;
          }
          const isSS = this.classList.contains("pdp-card-single");
          const pdpCardActiveClass = "pdp-active";

          // since this code is shared between vertical horizontal and dropdown. We need to prevent a click on select dropdown from fire multiple times
          if (
            this.classList.contains(pdpCardActiveClass) ||
            e.target.nodeName.toUpperCase() === "SELECT"
          ) {
            return;
          }

          const pdpDetails = pdpElement.querySelector(".pdp-selector-details");

          // hide pdp details
          pdpDetails.classList.toggle("pdp-hide-freq", true);

          pdpElement.querySelectorAll(".pdp-card").forEach(function (el) {
            el.classList.remove(pdpCardActiveClass);
            el.classList.remove("default-active");
          });

          this.classList.add(pdpCardActiveClass);

          const subDetails = pdpElement.querySelector(
            ".pdp-selector-details-sub"
          );
          const ssDetails = pdpElement.querySelector(
            ".pdp-selector-details-ss"
          );

          subDetails.classList.add("pdp-hide-freq");
          ssDetails.classList.add("pdp-hide-freq");

          clearTimeout(pdpElement.dataset?.detailToggleTimer);

          if (isSS) {
            pdpElement.dataset.detailToggleTimer = setTimeout(() => {
              ssDetails.classList.remove("pdp-hide-freq");
            }, 400);
          } else {
            pdpElement.dataset.detailToggleTimer = setTimeout(() => {
              pdpDetails.querySelector(".pdp-freq-selected").textContent =
                this.dataset.freq;
              subDetails.classList.remove("pdp-hide-freq");
            }, 400);
          }
        });
      }
    );

    // `click` listener for free gift information modal opener
    document.querySelectorAll(".product-selector .js-open-gift-info").forEach(
      /** @param {HTMLDivElement} el */ function (el) {
        const allFreqs = [];
        el.closest(".pdp-selector")
          .querySelectorAll(".pdp-card.pdp-sub-card")
          .forEach(function (card) {
            const freq = card.dataset.freq;
            const qty = card.dataset.qty;
            if (freq && qty > 1) {
              allFreqs.push(freq);
            }
          });
        allFreqs.sort((a, b) => a - b);
        const lower = allFreqs.shift();
        const higher = allFreqs.pop();
        const giftInfoModalOverlay = document.querySelector(
          ".gift-info-modal-overlay"
        );
        if (!lower || !higher || !giftInfoModalOverlay) {
          return;
        }
        el.addEventListener("click", function () {
          // const freq = el.closest(".pdp-card.pdp-sub-card").dataset.freq;
          // giftInfoModalOverlay
          //   .querySelectorAll(".month-lower")
          //   .forEach(function (elLower) {
          //     elLower.textContent = lower;
          //   });
          // giftInfoModalOverlay
          //   .querySelectorAll(".month-higher")
          //   .forEach(function (elHigher) {
          //     elHigher.textContent = higher;
          //   });
          // giftInfoModalOverlay
          //   .querySelectorAll(".modal-header")
          //   .forEach(function (modalHeader) {
          //     if (
          //       (modalHeader.classList.contains("modal-header-lower") &&
          //         freq == lower) ||
          //       (modalHeader.classList.contains("modal-header-higher") &&
          //         freq == higher)
          //     ) {
          //       modalHeader.style.display = "block";
          //     } else {
          //       modalHeader.style.display = "none";
          //     }
          //   });
          // giftInfoModalOverlay
          //   .querySelector(".month-toggle .three")
          //   .classList.toggle("selected", freq == lower);
          // giftInfoModalOverlay
          //   .querySelector(".month-toggle .six")
          //   .classList.toggle("selected", freq == higher);
          giftInfoModalOverlay.classList.add("show-modal");
        });
      }
    );

    document.querySelectorAll(".product-selector .js-add-item-btn").forEach(
      /** @param {HTMLButtonElement} el */ function (el) {
        el.addEventListener("click", that.addToCartHandler);
      }
    );
    

    document.querySelectorAll(".pdp-card-ss-qty-dropdown select").forEach(
      /** @param {HTMLSelectElement} selectEl */ function (selectEl) {
        selectEl.addEventListener("change", function () {
          this.closest(".pdp-card-single").dispatchEvent(new Event("click"));
          priceSelectorV2.ssCardSelectEvent(this);
        });
        selectEl.addEventListener("click", function () {
          this.closest(".pdp-card-single").dispatchEvent(new Event("click"));
          priceSelectorV2.ssCardSelectEvent(this);
        });
      }
    );

    // trigger click event to set up 3 month sub or SS qty1 if shopping suffixed or in param
    document.querySelectorAll(".pdp-selector").forEach(function (pdpElement) {
      const cardsToActivate =
        pdpElement.querySelector(
          window.hasShoppingParam
            ? ".pdp-card-single"
            : ".pdp-card.default-active"
        ) ?? pdpElement.querySelector(".pdp-card");
      if (cardsToActivate) {
        cardsToActivate.dispatchEvent(new Event("click"));
      }
    });
    // hero selector SS-link click
    document
      .querySelectorAll(".pdp-selector .pdp-card-premium .premium-link a")
      .forEach(function (premiumLink) {
        const variantId =
          premiumLink.closest(".pdp-card-premium")?.dataset.variantId;
        if (!variantId) {
          return;
        }
        premiumLink.addEventListener(
          "click",
          /** @param {Event} e */ function (e) {
            priceSelectorV2.addToCart(
              {
                id: variantId,
                quantity: 1,
                properties: priceSelectorV2.getIgPricesForSelector(
                  e.currentTarget.closest(".pdp-selector")
                ),
              },
              null,
              premiumLink
                .closest(".pdp-selector")
                .classList.contains("no-checkout-redirect")
            );
          }
        );
      });
  },

  preSelectSSOption: function () {
    const hasShoppingParam =
      new URLSearchParams(window.location.search).get("shopping") == "1";

    document.querySelectorAll(".pdp-selector").forEach((pdpSelector) => {
      const shoppingSelect = pdpSelector.querySelector(
        "#pdp-card-ss-qty-selector"
      );
      shoppingSelect?.setAttribute(
        "is-shopping",
        hasShoppingParam ? "true" : "false"
      );
      const variantSelectorShopping = pdpSelector.querySelector(
        ".pdp-card-ss-qty-option"
      );

      if (variantSelectorShopping) {
        variantSelectorShopping.dataset.shoppingParam = hasShoppingParam;
        if (hasShoppingParam) {
          const firstOption = shoppingSelect.querySelector("option");
          if (firstOption) {
            firstOption.selected = true;
          }
        } else {
          const secondOption = shoppingSelect.querySelector(
            "option:nth-child(2)"
          );
          if (secondOption) {
            secondOption.selected = true;
          }
        }
      }
    });
  },

  /**
   * @param {HTMLDivElement} pdpSelector The `div.pdp-selector` containing the 3
   * `div.pdp-sub-card`s with a `[data-variant-id]`
   * @returns {object} Intelligems' prices for the variants. This is an object
   * for items that have an active price test, the keys follow a format of
   * `_igp_{variant_id}` and the values are the bulk discounted price for the variant
   */
  getIgPricesForSelector: function (pdpSelector) {
    const prices = {};
    pdpSelector
      .querySelectorAll(".pdp-sub-card[data-variant-id]")
      .forEach(function (el) {
        const igPrice = window.igData.price.getPriceByVariantId(
          el.dataset.variantId
        );
        if (igPrice) {
          prices[`_igp_${el.dataset.variantId}`] = igPrice * 100;
        }
      });
    return prices;
  },

  /**
   * `click` callback function for the button to add an item to the cart
   * @param {MouseEvent} e
   */
  addToCartHandler: function (e) {
    /** @type {HTMLDivElement} pdpSelector */
    const pdpSelector = e.currentTarget.closest(".pdp-selector");
    if (!pdpSelector) {
      return;
    }

    const productSelector = pdpSelector.closest(".product-selector");
    if (!productSelector) {
      return;
    }

    const card = pdpSelector.querySelector(".pdp-card.pdp-active");
    if (!card) {
      return;
    }

    const giftModalOverlay = document.querySelector(".gift-modal-overlay");

    const isSS = card.classList.contains("pdp-card-single");
    const qty = isSS
      ? card.querySelector(".pdp-card-ss-qty-dropdown select")?.value
      : card.dataset.qty;
    const cartItem = {
      id: card.dataset.variantId,
      quantity: 1,
      properties: priceSelectorV2.getIgPricesForSelector(pdpSelector),
    };
    if (card.dataset.sellingPlan) {
      cartItem.selling_plan = card.dataset.sellingPlan;
    }

    // Store original product info globally to maintain state across modals
    window.originalCartItem = cartItem;
    window.skipCheckoutRedirect = pdpSelector.classList.contains("no-checkout-redirect");
    // Check if customer is eligible for free gift based on window.isES flag, subscription type, and quantity
    window.isGiftEligible = window.isES && !isSS && qty > 1;

    const upsellProductId = productSelector.dataset.upsellProductId;
    const upsellModalActive = document.querySelector(".product-modal-overlay .show-modal");
    const upsellModalOverlay = document.querySelector(".product-modal-overlay");
    
    // First check if upsell modal should be shown
    if (upsellProductId && !upsellModalActive && upsellModalOverlay) {
        // Pass data to the upsell modal
        upsellModalOverlay.querySelector(".modal").dataset.cartItem = JSON.stringify(cartItem);
        upsellModalOverlay.querySelector(".modal").dataset.noCheckoutRedirect = 
            pdpSelector.classList.contains("no-checkout-redirect") ? 1 : 0;
        upsellModalOverlay.querySelector(".modal").dataset.isGiftEligible = 
            window.isGiftEligible ? 1 : 0;
        upsellModalOverlay.classList.add("show-modal");
        return false;
    } 
    // If no upsell needed or if we're already in upsell flow, check for gift
    else if (window.isGiftEligible && giftModalOverlay) {
        giftModalOverlay.querySelector(".modal").dataset.cartItem = JSON.stringify(cartItem);
        giftModalOverlay.querySelector(".modal").dataset.noCheckoutRedirect = 
            pdpSelector.classList.contains("no-checkout-redirect") ? 1 : 0;
        giftModalOverlay.classList.add("show-modal");
        return false;
    }


    console.log("addToCart");
    console.log(cartItem);
    priceSelectorV2.addToCart(
      cartItem,
      null,
      pdpSelector.classList.contains("no-checkout-redirect")
    );
  }, 

  /**
   * @param {{id: number, quantity: 1, selling_plan?: number}} item `id` being
   * the variant ID. `quantity` should always be `1`. The `selling_plan` should
   * be specified for subscriptions.
   * @param {number|undefined} giftVariantId Variant ID for an (optional) gift.
   */
  addToCart: function (item, giftVariantId) {
    this.miniCart = document.querySelector("mini-cart");
    const sections = this.miniCart
      ? this.miniCart.getSectionsToRender().map((section) => section.id)
      : [];

    const cart = {
      items: [item],
      sections: sections,
      sections_url: window.location.pathname,
    };
    if (giftVariantId) {
      cart.items.push({
        id: giftVariantId,
        quantity: 1,
        properties: {
          _igGWP: "1",
        },
      });
    }
 
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cart),
    })
      .then((response) => response.json())
      //window.location.href = "/checkout";
      .then((response) => {
        // item is added to cart at this point
        // we can go to checkout or do something else.
        document
          .querySelectorAll(".modal-overlay.show-modal")
          .forEach((modalOverlay) =>
            modalOverlay.classList.remove("show-modal")
          );
        if (this.miniCart) {
          this.miniCart.renderContents(response);
        } else {
          window.location.href = "/checkout";
        }
      })
      .catch((error) => {
        alert("Item could not be added to cart, please try again.");
        console.error("Err:", error);
      });
  },

  addMultipleItemsToCart: function(items, giftVariantId, noCheckoutRedirect) {
    this.miniCart = document.querySelector("mini-cart");
    const sections = this.miniCart
      ? this.miniCart.getSectionsToRender().map((section) => section.id)
      : [];
  
    const cartItems = [...items]; // Clone the items array

    // assign upsell product
    if (cartItems.length > 1) {
      const originalItem = cartItems[0];
      const upsellItem = cartItems[1];
      
      // Add bundling properties to the upsell product
      if (!upsellItem.properties) {
        upsellItem.properties = {};
      }
      
      // Use the same property pattern as the gift items
      upsellItem.properties._igUpsell = originalItem.id;
    }
    
    if (giftVariantId) {
      cartItems.push({
        id: giftVariantId,
        quantity: 1,
        properties: {
          _igGWP: "1",
        },
      });
    }
    
    const cart = {
      items: cartItems,
      sections: sections,
      sections_url: window.location.pathname,
    };
  
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cart),
    })
      .then((response) => response.json())
      .then((response) => {
        document
          .querySelectorAll(".modal-overlay.show-modal")
          .forEach((modalOverlay) => modalOverlay.classList.remove("show-modal"));
          
        if (this.miniCart) {
          this.miniCart.renderContents(response);
        } else if (!noCheckoutRedirect) {
          window.location.href = "/checkout";
        }
      })
      .catch((error) => {
        alert("Items could not be added to cart, please try again.");
        console.error("Error:", error);
      });
  },

  /**
   * Callback for when the <select>'s value in the Straight Sale card changes.
   * Sets qty, price, and variantId dataset values. Also sets text content for
   * the selected quantity.
   * @param {HTMLSelectElement} element
   */
  ssCardSelectEvent: function (element) {
    const pdpElement = element.closest(".pdp-selector");
    if (!pdpElement) {
      return;
    }

    // adjust SS data attributes to reflect change
    const ssCard = pdpElement.querySelector(".pdp-card-single");
    const selected = element.options[element.selectedIndex];
    ssCard.dataset.qty = element.value;
    ssCard.dataset.price = selected.dataset.price;
    ssCard.dataset.variantId = selected.dataset.id;
    ssCard.querySelector(".pdp-card-price-dollars").textContent =
      "$" + selected.dataset.eachDollars;
    ssCard.querySelector(".pdp-card-price-cents").textContent =
      selected.dataset.eachCents;
    ssCard.querySelector(".pdp-card-saving-amount").textContent =
      selected.dataset.savingsText;
    ssCard.querySelector(".pdp-card-saving-percent span").textContent =
      selected.dataset.percentText;
  },

  triggerAllSSCardSelects: function () {
    const that = this;
    document
      .querySelectorAll(".pdp-card-ss-qty-dropdown select")
      .forEach(function (el) {
        priceSelectorV2.ssCardSelectEvent(el);
        const ssCard = el.closest(".pdp-card-single");
        if (that.hasShoppingParam) {
          const oldCard = el
            .closest(".pdp-selector")
            .querySelector(".pdp-active");
          oldCard.classList.remove("pdp-active");
          ssCard.classList.add("pdp-active");
        }
        if (ssCard.classList.contains("pdp-active")) {
          ssCard.dispatchEvent(new Event("click"));
        }
      });
  },

  /**
   * Callback for when Intelligems is ready.
   * Performs DOM manipulations as needed to reflect price tests and discount campaigns.
   */
  onIgReady: function () {
    var self = this;
    document.querySelectorAll(".pdp-selector").forEach(
      /** @param {HTMLDivElement} selectorEl */ function (selectorEl) {
        let maxDiscountPercentage = 0;
        const qtyOneCard = selectorEl.querySelector(
          '.pdp-sub-card[data-canonical-quantity="1"]'
        );
        if (!qtyOneCard) {
          console.log("No subscription card with canonical quantity 1 found in selector:", selectorEl);
          console.log("Selector ID:", selectorEl.id);
          console.log("Selector classes:", selectorEl.className);
          return; // Skip this selector if the card doesn't exist 
        }
        const basePrice =
          window.igData.price.getComparePriceByVariantId(
            qtyOneCard.dataset.variantId
          ) || qtyOneCard.dataset.basePrice;
        // Edit the subscription cards
        selectorEl.querySelectorAll(".pdp-sub-card").forEach(
          /** @param {HTMLDivElement} subCard */ function (subCard) {
            const itemBasePrice = basePrice * subCard.dataset.canonicalQuantity;
            subCard.dataset.basePrice = itemBasePrice;
            const itemBulkDiscountedPrice =
              window.igData.price.getPriceByVariantId(
                subCard.dataset.variantId
              ) || subCard.dataset.bulkPrice;
            subCard.dataset.bulkPrice = itemBulkDiscountedPrice;
            let fullyDiscountedPrice =
              itemBulkDiscountedPrice -
              (itemBulkDiscountedPrice *
                subCard.dataset.subDiscountPercentage) /
                100;
            /*
            // BFCM Subtract 20% from the final price
            fullyDiscountedPrice =
              fullyDiscountedPrice - (fullyDiscountedPrice * 20) / 100;
            */
            const discountAmount = itemBasePrice - fullyDiscountedPrice;
            const discountPercentage = (discountAmount * 100) / itemBasePrice;
            if (discountPercentage > maxDiscountPercentage) {
              maxDiscountPercentage = discountPercentage;
            }
            // Add 20% to the html data attr discount
            subCard.dataset.discountPercentage = discountPercentage;

            // BFCM Save percentage
            subCard.querySelector(".js-pdp-sub-card-perc-off").innerText =
              Math.round(discountPercentage);
            // BFCM Save percentage END
            subCard.querySelector(".js-pdp-sub-card-total-off").innerText =
              "$" + (discountAmount.toFixed(2) + "").replace(".00", "");
            const perUnitParts = (
              (
                fullyDiscountedPrice / subCard.dataset.canonicalQuantity
              ).toFixed(2) + ""
            ).split(".");
            // BFCM Price Discount
            const perUnitDollars = Math.trunc(perUnitParts[0]);
            const perUnitCents = perUnitParts[1];
            // BFCM Price Discount End
            subCard.querySelector(".pdp-card-price-dollars span").innerText =
              perUnitDollars;
            subCard.querySelector(".pdp-card-price-cents").innerText =
              perUnitCents;
          }
        );
        // Edit the one-time-purchase options
        selectorEl.querySelectorAll(".pdp-card-ss-qty-dropdown option").forEach(
          /** @param {HTMLOptionElement} */ function (optionEl) {
            const itemBulkDiscountedPrice =
              window.igData.price.getPriceByVariantId(optionEl.dataset.id) ||
              optionEl.dataset.price;
            let fullyDiscountedPrice = itemBulkDiscountedPrice;
            fullyDiscountedPrice -= self.getIgCampaignsDiscount(
              optionEl.dataset.id,
              optionEl.value,
              itemBulkDiscountedPrice
            );
            if (fullyDiscountedPrice < 0) {
              fullyDiscountedPrice = 0;
            }
            /*
            // BFCM Subtract 20% from the final price
            fullyDiscountedPrice =
              fullyDiscountedPrice - (fullyDiscountedPrice * 20) / 100;
            */
            const discountPercentage =
              ((basePrice * optionEl.value - fullyDiscountedPrice) * 100) /
              (basePrice * optionEl.value);
            if (discountPercentage > maxDiscountPercentage) {
              maxDiscountPercentage = discountPercentage;
            }

            optionEl.dataset.percentText =
              discountPercentage > 0
                ? `Save ${Math.round(discountPercentage)}%`
                : "Market Price";
            optionEl.dataset.price = fullyDiscountedPrice;
            const unitPrice = fullyDiscountedPrice / optionEl.value;
            const perDayCost = unitPrice / selectorEl.dataset.supplyDays;
            const unitPriceParts = (unitPrice.toFixed(2) + "").split(".");
            optionEl.dataset.each = unitPrice;
            optionEl.dataset.savingsText =
              "Only $" + perDayCost.toFixed(2) + " per day";
            optionEl.dataset.eachDollars = unitPriceParts[0];
            optionEl.dataset.eachCents = unitPriceParts[1];

            priceSelectorV2.ssCardSelectEvent(optionEl.closest("select"));
          }
        );
        const premiumLink = selectorEl.querySelector(".pdp-card-premium");
        if (premiumLink) {
          let premiumLinkPrice =
            window.igData.price.getPriceByVariantId(
              premiumLink.dataset.variantId
            ) || premiumLink.dataset.bulkPrice;
          let premiumLinkBasePrice =
            window.igData.price.getComparePriceByVariantId(
              premiumLink.dataset.variantId
            ) || premiumLink.dataset.basePrice;
          premiumLink.dataset.bulkPrice = premiumLinkPrice;
          premiumLinkPrice -= self.getIgCampaignsDiscount(
            premiumLink.dataset.variantId,
            premiumLink.dataset.qty,
            premiumLinkPrice
          );
          premiumLink.dataset.discountPercentage =
            ((premiumLinkBasePrice - premiumLinkPrice) /
              premiumLink.dataset.basePrice) *
            100;
          premiumLink.querySelector(".premium-shipping").style.display =
            premiumLinkPrice >= premiumLink.dataset.shippingThreshold
              ? "none"
              : "";
          premiumLink.querySelector(".premium-price").innerText =
            "$" + parseFloat(premiumLinkPrice).toFixed(2).replace(".00", "");
        }
        const upToPercEl = selectorEl
          .closest(".product-selector")
          .querySelector(".js-up-to-perc-off");
        if (upToPercEl) {
          upToPercEl.innerText = Math.round(maxDiscountPercentage);
        }
      }
    );
  },
  /**
   * Returns the applicable Intelligems campagins discount for a given variant
   * @param {number} variantId
   * @param {number} variantQuantity
   * @param {number} variantBulkPrice The variant's price, not the "Compare At" price
   * @return {number} The total discount amount from applicable campaigns
   */
  getIgCampaignsDiscount: function (
    variantId,
    variantQuantity,
    variantBulkPrice
  ) {
    let applicableDiscount = 0;
    window.igData.campaigns
      .getAll()
      .filter(function (campaign) {
        if (!campaign.discount) {
          return false;
        }
        if (campaign.discount.testProducts.length === 0) {
          return true;
        }
        // Filter out hardcoded volume discounts
        if (/6bb65d0dd629$/.test(campaign.campaignId)) {
          return false;
        }
        // Only campaigns that include the product should be considered
        for (let k = 0; k < campaign.discount.testProducts.length; k++) {
          for (
            let m = 0;
            m < campaign.discount.testProducts[k].variants.length;
            m++
          ) {
            if (campaign.discount.testProducts[k].variants[m].id == variantId) {
              return true;
            }
          }
        }
        return false;
      })
      .forEach(function (campaign) {
        const applicableTiers = campaign.discount.tiers
          .filter(function (tier) {
            // Filter out discount tiers that don't fit for this variant
            if (tier.isFreeShipping || tier.isGiftWithPurchase) {
              return false;
            }
            switch (campaign.discount.unitType) {
              case "unit":
                return (
                  variantQuantity >= tier.minimumUnits &&
                  variantQuantity <= tier.maximumUnits
                );
              case "dollar":
                return (
                  variantBulkPrice >= tier.minimumUnits &&
                  variantBulkPrice <= tier.maximumUnits
                );
              default:
                console.error(
                  "Unsupported discount.unitType",
                  campaign.discount.unitType
                );
                return false;
            }
          })
          .sort(function (tierA, tierB) {
            // Sort descending by minimum units so that the best applicable tier
            // is the first element (in case more than one tier applies)
            return tierB.minimumUnits - tierA.minimumUnits;
          });
        if (applicableTiers.length === 0) {
          return;
        }
        switch (campaign.discount.discountType) {
          case "percentage":
            applicableDiscount +=
              (variantBulkPrice * applicableTiers[0].unitDiscount) / 100;
            break;
          case "dollar":
            applicableDiscount += applicableTiers[0].unitDiscount;
            break;
          default:
            console.error(
              "Unsupported discount.discountType",
              campaign.discount.discountType
            );
            break;
        }
      });
    return applicableDiscount;
  },
};

window.igReadyAggregator.addIgReadyListener(function () {
  priceSelectorV2.onIgReady();
  priceSelectorV2.triggerAllSSCardSelects();
});

document.addEventListener("DOMContentLoaded", function () {
  priceSelectorV2.init();
});

window.addEventListener("pageshow", function () {
  priceSelectorV2.triggerAllSSCardSelects();
});

window.priceSelectorV2 = priceSelectorV2;

// HSA/FSA Popup

document.addEventListener("DOMContentLoaded", function () {
  const popupOverlay = document.querySelector(".trumed-popup-overlay");
  const popupClose = document.querySelector(".trumed-popup-close");
  const triggers = document.querySelectorAll(
    ".trumed-image, .trumed-anchor-link"
  );

  // Show popup
  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      popupOverlay.style.display = "flex";
    });
  });

  // Close popup
  popupClose.addEventListener("click", () => {
    popupOverlay.style.display = "none";
  });

  // Close on overlay click
  popupOverlay.addEventListener("click", (event) => {
    if (event.target === popupOverlay) {
      popupOverlay.style.display = "none";
    }
  });
});